export class MedicalSupply {
    id = null;
    name = null;
    code = null;
    description = null;
    unit = null;
    price = null;
}